module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    directives: [{
      name: "drag-modal",
      rawName: "v-drag-modal"
    }],
    attrs: {
      "title": "老师基本信息",
      "width": "1000px"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Tabs', {
    key: _vm.tabBarKey,
    attrs: {
      "type": "card",
      "animated": false
    },
    on: {
      "on-click": _vm.onTabClick
    },
    model: {
      value: (_vm.tabName),
      callback: function($$v) {
        _vm.tabName = $$v
      },
      expression: "tabName"
    }
  }, [_c('Tab-pane', {
    attrs: {
      "label": "基本信息",
      "name": "基本信息"
    }
  }, [_c('Form', {
    ref: "tchForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.tchRule
    }
  }, [_c('Row', {
    attrs: {
      "span": "24"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Row', [_c('Tag', {
    staticStyle: {
      "margin": "0 0 20px 20px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("基本信息")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "align": "middle"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "First Name：",
      "prop": "firstName"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.firstName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "firstName", $$v)
      },
      expression: "formData.firstName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "Last Name：",
      "prop": "lastName"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.lastName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lastName", $$v)
      },
      expression: "formData.lastName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "Full Name：",
      "prop": "fullName"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.fullName),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "fullName", $$v)
      },
      expression: "formData.tchForm.fullName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label-width": 90,
      "label": "注册渠道："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.tchForm.regFrom),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "regFrom", $$v)
      },
      expression: "formData.tchForm.regFrom"
    }
  }, _vm._l((_vm.enabledChannelOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.param
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "密码：",
      "required": _vm.isAddTch
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.formData, "newPassword", $$v)
      },
      expression: "formData.newPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "20"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "性别：",
      "prop": "sex"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.sex),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sex", $$v)
      },
      expression: "formData.sex"
    }
  }, _vm._l((_vm.$constant.sex), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                          ")])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "8",
      "offset": "3"
    }
  }, [_c('a', {
    on: {
      "click": _vm.redirectToTchSystem
    }
  }, [_c('img', {
    staticStyle: {
      "width": "120px",
      "height": "120px"
    },
    attrs: {
      "src": _vm.totalImageUrl
    }
  })]), _vm._v(" "), _c('single-one-pic-upload', {
    attrs: {
      "text": _vm.text
    },
    on: {
      "on-file-change": _vm.handleResult
    }
  })], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "来源：",
      "prop": "channel"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.channel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "channel", $$v)
      },
      expression: "formData.channel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                      ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [(_vm.showBirthday) ? _c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "生日：",
      "prop": "birthday"
    }
  }, [_c('Input', {
    attrs: {
      "type": "date",
      "name": "birthday"
    },
    on: {
      "on-change": _vm.onBirthdayChange
    },
    model: {
      value: (_vm.formData.birthday),
      callback: function($$v) {
        _vm.$set(_vm.formData, "birthday", $$v)
      },
      expression: "formData.birthday"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "期望时薪：",
      "prop": "channel"
    }
  }, [_c('Input', {
    attrs: {
      "name": "salary"
    },
    on: {
      "on-blur": function($event) {
        return _vm.validateNumericField(_vm.formData.tchForm, 'expectSalary')
      }
    },
    model: {
      value: (_vm.formData.tchForm.expectSalary),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "expectSalary", $$v)
      },
      expression: "formData.tchForm.expectSalary"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "学历："
    }
  }, [_c('Input', {
    attrs: {
      "name": "eduLevel",
      "placeholder": "例如：本科"
    },
    model: {
      value: (_vm.formData.eduLevel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "eduLevel", $$v)
      },
      expression: "formData.eduLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "合同："
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.editContract()
      }
    }
  }, [_vm._v("查看合同")])])], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "国籍："
    }
  }, [_c('Input', {
    attrs: {
      "name": "country"
    },
    model: {
      value: (_vm.formData.country),
      callback: function($$v) {
        _vm.$set(_vm.formData, "country", $$v)
      },
      expression: "formData.country"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "口音："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.accent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "accent", $$v)
      },
      expression: "formData.accent"
    }
  }, _vm._l((_vm.$constant.accent), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                      ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [(!_vm.isAddTch || _vm.saveType === 'agency') ? _c('i-col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "类型：",
      "prop": "category"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "disabled": _vm.isAddTch && _vm.saveType === 'agency'
    },
    model: {
      value: (_vm.formData.category),
      callback: function($$v) {
        _vm.$set(_vm.formData, "category", _vm._n($$v))
      },
      expression: "formData.category"
    }
  }, _vm._l((_vm.$constant.teacherCategory), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                      ")])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "年龄：",
      "prop": "age"
    }
  }, [_c('InputNumber', {
    attrs: {
      "max": 100,
      "min": 1
    },
    on: {
      "on-change": _vm.onAgeChange
    },
    model: {
      value: (_vm.formData.age),
      callback: function($$v) {
        _vm.$set(_vm.formData, "age", $$v)
      },
      expression: "formData.age"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [(_vm.canEdit) ? _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": _vm.formData.tchChannel === 1 ? '时薪：' : '时薪：'
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "name": "salary"
    },
    on: {
      "on-blur": function($event) {
        return _vm.validateNumericField(_vm.formData, 'salary')
      }
    },
    model: {
      value: (_vm.formData.salary),
      callback: function($$v) {
        _vm.$set(_vm.formData, "salary", $$v)
      },
      expression: "formData.salary"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#666"
    }
  }, [_vm._v("对外展示")]), _vm._v(" "), _c('i-switch', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.tchForm.showSalary),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "showSalary", $$v)
      },
      expression: "formData.tchForm.showSalary"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isAddTch) ? _c('i-col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "授课类型：",
      "prop": "tchType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.tchType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tchType", _vm._n($$v))
      },
      expression: "formData.tchType"
    }
  }, _vm._l((_vm.$constant.tchType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                      ")])
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "合同开始时间："
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.crtBeginTimeDateChange
    },
    model: {
      value: (_vm.formData.crtBeginTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "crtBeginTime", $$v)
      },
      expression: "formData.crtBeginTime"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "合同结束时间："
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.crtEndTimeDateChange
    },
    model: {
      value: (_vm.formData.crtEndTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "crtEndTime", $$v)
      },
      expression: "formData.crtEndTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "介绍视频："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleIntroduceVideoUrl,
      "on-success": _vm.IntroduceVideoUrlSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUploadIntroduceVideoUrl,
      "accept": "video/*",
      "limit": 2,
      "multiple": "",
      "file-list": _vm.introduceVideoUrlList
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "light",
      "content": "不得超过500M",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.introduceVideoUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.introduceVideoUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.introduceVideoUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('VIDEO')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.formData.editPermission) ? _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "国籍图片："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleNationalityImageChange,
      "on-success": _vm.nationalityImageSuccess,
      "on-remove": _vm.nationalityImageRemove,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUploadNationalityImage,
      "accept": "image/*",
      "limit": 1,
      "file-list": _vm.nationalityImageUrlList
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "light",
      "content": "不得超过30M",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.nationalityImageUrl) ? _c('div', {
    staticClass: "image-preview"
  }, [_c('viewer', [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "margin-top": "10px",
      "cursor": "pointer"
    },
    attrs: {
      "src": _vm.nationalityImageUrl,
      "alt": "国籍图片预览"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.nationalityImageUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.nationalityImageUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.nationalityImageUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('NATIONALITY_IMAGE')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "上课片段："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTeachVideo,
      "on-success": _vm.teachVideoSuccess,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUploadTeachVideo,
      "on-progress": _vm.handleProgress,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.teachVideoList
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "light",
      "content": "不得超过500M",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": 100
    }
  }, _vm._l((_vm.teachVideoList), function(item, index) {
    return _c('li', [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item),
        expression: "item"
      }],
      on: {
        "click": function($event) {
          return _vm.openImage(item)
        }
      }
    }, [_vm._v("查看")])])
  }), 0)], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "外教介绍："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "maxlength": 500,
      "autosize": {
        minRows: 1,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.formData.sign),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sign", $$v)
      },
      expression: "formData.sign"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Row', [_c('Tag', {
    staticStyle: {
      "margin": "0 0 20px 20px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("教学属性")])], 1), _vm._v(" "), _c('Row', [(_vm.canEdit && _vm.showTchSelf) ? _c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "老师上传："
    }
  }, [_c('i-col', [_c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label": "TESOL："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTESOL,
      "on-success": _vm.TESOLSuccess,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.certificateTesolUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.certificateTesolUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.certificateTesolUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.certificateTesolUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('TESOL')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('i-col', [_c('Form-item', {
    attrs: {
      "label": "TEFL："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTEFL,
      "on-success": _vm.TEFLSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.certificateTeflUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.certificateTeflUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.certificateTeflUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.certificateTeflUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('TEFL')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('i-col', [_c('Form-item', {
    attrs: {
      "label": "英语专业："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleEnglish,
      "on-success": _vm.EnglishSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.certificateEnglishUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.certificateEnglishUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.certificateEnglishUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.certificateEnglishUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('ENGLISH')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label": "简历："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleResume,
      "on-success": _vm.resumeSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.resumeList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.resume) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.resume)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.resume) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('RESUME')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('i-col', [_c('Form-item', {
    attrs: {
      "label": "自我介绍视频："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleSelfIntroductionVideo,
      "on-success": _vm.selfIntroductionVideoSuccess,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUploadIntroductionVideo,
      "on-progress": _vm.handleProgress,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.selfIntroductionVideoList
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "light",
      "content": "不得超过500M",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selfIntroductionVideo),
      expression: "selfIntroductionVideo"
    }],
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.selfIntroductionVideo)
      }
    }
  }, [_vm._v("查看")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selfIntroductionVideo),
      expression: "selfIntroductionVideo"
    }],
    on: {
      "click": function($event) {
        return _vm.deleteUrl('SELFINTRODUCTIONVIDEO')
      }
    }
  }, [_vm._v("删除")])], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "对外展示："
    }
  }, [_c('i-col', [_c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label": "TESOL："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTESOLOut,
      "on-success": _vm.TESOLOutSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.certificateTesolOutUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.certificateTesolOutUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.certificateTesolOutUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.certificateTesolOutUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('TESOLOut')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('i-col', [_c('Form-item', {
    attrs: {
      "label": "TEFL："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTEFLOut,
      "on-success": _vm.TEFLOutSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.certificateTeflOutUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.certificateTeflOutUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.certificateTeflOutUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.certificateTeflOutUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('TEFLOut')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label": "TEYL："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTEYL,
      "on-success": _vm.TEYLSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.certificateTeylUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.certificateTeylUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.certificateTeylUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.certificateTeylUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('TEYL')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('i-col', [_c('Form-item', {
    attrs: {
      "label": "英语专业："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleEnglishOut,
      "on-success": _vm.EnglishOutSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.certificateEnglishOutUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1), _vm._v(" "), (_vm.certificateEnglishOutUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.certificateEnglishOutUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.certificateEnglishOutUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('ENGLISHOut')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "教学经验："
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.experience),
      callback: function($$v) {
        _vm.$set(_vm.formData, "experience", $$v)
      },
      expression: "formData.experience"
    }
  }, _vm._l((20), function(i) {
    return _c('Option', {
      key: i,
      attrs: {
        "value": String(i)
      }
    }, [_vm._v(_vm._s(i))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "教学特色："
    }
  }, [_c('CheckboxGroup', {
    model: {
      value: (_vm.featuresArray),
      callback: function($$v) {
        _vm.featuresArray = $$v
      },
      expression: "featuresArray"
    }
  }, [_c('Checkbox', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("会中文")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("长的好看")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("道具多")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "4"
    }
  }, [_vm._v("活泼")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "5"
    }
  }, [_vm._v("TPR优秀")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "6"
    }
  }, [_vm._v("在中国教过书")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "7"
    }
  }, [_vm._v("会板书")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "8"
    }
  }, [_vm._v("会拓展")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "99"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "适宜级别："
    }
  }, [_c('CheckboxGroup', {
    model: {
      value: (_vm.levelArray),
      callback: function($$v) {
        _vm.levelArray = $$v
      },
      expression: "levelArray"
    }
  }, [_c('Checkbox', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("Level1")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "5"
    }
  }, [_vm._v("Level2")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("Level3-Level5")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("Level6-Level9")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "4"
    }
  }, [_vm._v("Wonders及其他")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "6"
    }
  }, [_vm._v("PU")])], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "在线简历："
    }
  }, [(_vm.formData.id) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openDetailLink()
      }
    }
  }, [_vm._v("老师简历(网页版)")]) : _vm._e()]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": 160,
      "label": "磨课视频/优秀上课展示："
    }
  }, _vm._l((_vm.polishLessonVideoList), function(url, index) {
    return _c('div', {
      key: 'polish-' + index,
      staticStyle: {
        "margin-bottom": "6px"
      }
    }, [_c('Input', {
      staticStyle: {
        "width": "280px"
      },
      attrs: {
        "placeholder": "粘贴文件地址"
      },
      model: {
        value: (_vm.polishLessonVideoList[index]),
        callback: function($$v) {
          _vm.$set(_vm.polishLessonVideoList, index, $$v)
        },
        expression: "polishLessonVideoList[index]"
      }
    }), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (url),
        expression: "url"
      }],
      staticStyle: {
        "margin-left": "8px"
      },
      on: {
        "click": function($event) {
          return _vm.openImage(url)
        }
      }
    }, [_vm._v("查看")]), _vm._v(" "), (index === _vm.polishLessonVideoList.length - 1 && _vm.polishLessonVideoList.length < 10) ? _c('i', {
      staticClass: "el-icon-circle-plus-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-left": "8px",
        "cursor": "pointer",
        "color": "#0ABB08"
      },
      on: {
        "click": _vm.addPolishLessonVideoRow
      }
    }) : _vm._e()], 1)
  }), 0)], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "老师介绍："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleIntroduceDoc,
      "on-success": _vm.IntroduceDocSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "accept": "application/*",
      "before-upload": _vm.beforeUpload,
      "limit": 2,
      "multiple": "",
      "file-list": _vm.introduceDocUrlList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1), _vm._v(" "), (_vm.introduceDocUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.introduceDocUrl)
      }
    }
  }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.introduceDocUrl) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.deleteUrl('DOC')
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "风采展示(照片)："
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTeachImages,
      "on-success": _vm.teachImagesSuccess,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUploadTeachImages,
      "on-progress": _vm.handleProgress,
      "limit": 10,
      "multiple": true,
      "file-list": _vm.teachImagesList
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "light",
      "content": "不得超过30M",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": 100
    }
  }, _vm._l((_vm.images), function(item, index) {
    return _c('li', [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item),
        expression: "item"
      }],
      on: {
        "click": function($event) {
          return _vm.openImage(item)
        }
      }
    }, [_vm._v("查看")]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item),
        expression: "item"
      }],
      on: {
        "click": function($event) {
          return _vm.deleteImages('IMAGES', item)
        }
      }
    }, [_vm._v("删除")])])
  }), 0)], 1), _vm._v(" "), (_vm.formData.account && _vm.canEdit) ? _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "登录账号:"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.formData.account) + "\n                  ")])], 1) : _vm._e(), _vm._v(" "), _c('Row', [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "备注："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "maxlength": 200,
      "autosize": {
        minRows: 1,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px dotted #ddd"
    }
  }), _vm._v(" "), _c('Row', [_c('i-col', {
    staticStyle: {
      "border-right": "1px dotted #ddd"
    }
  }, [_c('Row', {
    attrs: {
      "span": "12"
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("紧急联系方式")])], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "邮箱："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.email),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "email", $$v)
      },
      expression: "formData.tchForm.email"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "紧急电话："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.mobileSos),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "mobileSos", $$v)
      },
      expression: "formData.tchForm.mobileSos"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "Whatsapp账号："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.whatAccount),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "whatAccount", $$v)
      },
      expression: "formData.tchForm.whatAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "Facebook账号："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.faceBook),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "faceBook", $$v)
      },
      expression: "formData.tchForm.faceBook"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Row', {
    attrs: {
      "span": "24"
    }
  }, [(_vm.canEdit) ? _c('i-col', {
    staticStyle: {
      "border-right": "1px dotted #ddd"
    },
    attrs: {
      "span": "12"
    }
  }, [_c('Row', {
    attrs: {
      "span": "12"
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("联系方式")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "span": "10"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 85,
      "label": "区号："
    }
  }, [_c('phone-area-select', {
    attrs: {
      "areaNumValue": _vm.formData.areaNum
    },
    on: {
      "on-change": _vm.onAreaNumChange
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": 85,
      "label": "Microsoft Teams ID："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.skype),
      callback: function($$v) {
        _vm.$set(_vm.formData, "skype", $$v)
      },
      expression: "formData.skype"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 85,
      "label": "手机号码："
    }
  }, [_c('Input', {
    attrs: {
      "number": true,
      "placeholder": "手机号和邮箱至少填一个"
    },
    model: {
      value: (_vm.formData.mobile),
      callback: function($$v) {
        _vm.$set(_vm.formData, "mobile", $$v)
      },
      expression: "formData.mobile"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": 85,
      "label": "email："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "手机号和邮箱至少填一个"
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  })], 1), _vm._v(" "), (_vm.isAddTch) ? _c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "登录方式：",
      "prop": "loginBy"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.loginBy),
      callback: function($$v) {
        _vm.$set(_vm.formData, "loginBy", $$v)
      },
      expression: "formData.loginBy"
    }
  }, _vm._l((_vm.$constant.loginBy), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Row', {
    attrs: {
      "span": "12"
    }
  }, [_c('Tag', {
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("系统权限")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "span": "10"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "试听权限：",
      "prop": "isAudition"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.isAudition),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isAudition", $$v)
      },
      expression: "formData.isAudition"
    }
  }, _vm._l((_vm.$constant.yn), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "是否录屏："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.isRecordScreen),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isRecordScreen", $$v)
      },
      expression: "formData.isRecordScreen"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "专属老师："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.serviceType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "serviceType", $$v)
      },
      expression: "formData.serviceType"
    }
  }, _vm._l((_vm.$constant.serviceType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "span": "10"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "临时约课权限："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.tempSchedule),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tempSchedule", $$v)
      },
      expression: "formData.tempSchedule"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "16"
    }
  }, [_c('FormItem', {
    attrs: {
      "label-width": 80,
      "label": "无试听权限原因："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.invalidListenCause),
      callback: function($$v) {
        _vm.$set(_vm.formData, "invalidListenCause", $$v)
      },
      expression: "formData.invalidListenCause"
    }
  }), _vm._v(" "), (_vm.tchId) ? _c('a', {
    staticStyle: {
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.showInvalidListenCauseLog = true
      }
    }
  }, [_vm._v("历史")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "span": "10"
    }
  }), _vm._v(" "), _c('Row', {
    attrs: {
      "span": "10"
    }
  }, [(this.tchId) ? _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", _vm._n($$v))
      },
      expression: "formData.status"
    }
  }, _vm._l((_vm.$constant.teacherStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "可绑定权限：",
      "prop": "isCanBound"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.isCanBound),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isCanBound", _vm._n($$v))
      },
      expression: "formData.isCanBound"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "是否standby：",
      "prop": "isStandby"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.isStandby),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isStandby", _vm._n($$v))
      },
      expression: "formData.isStandby"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "19:00-20:30不可用",
      "prop": "isStandby"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.disable18),
      callback: function($$v) {
        _vm.$set(_vm.formData, "disable18", _vm._n($$v))
      },
      expression: "formData.disable18"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px dotted #ddd",
      "margin-top": "20px"
    }
  }), _vm._v(" "), _c('Row', [_c('i-col', {
    staticStyle: {
      "border-right": "1px dotted #ddd"
    }
  }, [_c('Row', {
    attrs: {
      "span": "12"
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("其他信息")])], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "所在城市："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.townOrCity),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "townOrCity", $$v)
      },
      expression: "formData.tchForm.townOrCity"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "当前居住地："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "毕业院校："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.school),
      callback: function($$v) {
        _vm.$set(_vm.formData, "school", $$v)
      },
      expression: "formData.school"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "大学专业："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.major),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "major", $$v)
      },
      expression: "formData.tchForm.major"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "毕业年份："
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "year",
      "placeholder": "Select year",
      "value": _vm.formData.tchForm.yearOfGraduation
    },
    on: {
      "on-change": _vm.onYearChange
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "上传速度："
    }
  }, [_c('Input', {
    on: {
      "on-blur": function($event) {
        return _vm.validateNumericField(_vm.formData, 'upSpeed')
      }
    },
    model: {
      value: (_vm.formData.upSpeed),
      callback: function($$v) {
        _vm.$set(_vm.formData, "upSpeed", $$v)
      },
      expression: "formData.upSpeed"
    }
  }, [_c('span', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_vm._v("Mbps")])])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "下载速度："
    }
  }, [_c('Input', {
    on: {
      "on-blur": function($event) {
        return _vm.validateNumericField(_vm.formData, 'downSpeed')
      }
    },
    model: {
      value: (_vm.formData.downSpeed),
      callback: function($$v) {
        _vm.$set(_vm.formData, "downSpeed", $$v)
      },
      expression: "formData.downSpeed"
    }
  }, [_c('span', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_vm._v("Mbps")])])], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "备用网络："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.backUpInternetSpeed),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "backUpInternetSpeed", $$v)
      },
      expression: "formData.tchForm.backUpInternetSpeed"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "备用电源："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.backUpPower),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "backUpPower", $$v)
      },
      expression: "formData.tchForm.backUpPower"
    }
  })], 1)], 1), _vm._v(" "), (_vm.formData.editPermission) ? _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "网络供应商："
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.tchForm.networkProviders),
      callback: function($$v) {
        _vm.$set(_vm.formData.tchForm, "networkProviders", $$v)
      },
      expression: "formData.tchForm.networkProviders"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px dotted #ddd",
      "margin-top": "20px"
    }
  }), _vm._v(" "), _c('Row', [(_vm.formData.editPermission) ? _c('i-col', [_c('Row', {
    attrs: {
      "span": "12"
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("课表登记")])], 1), _vm._v(" "), _c('span', {
    staticClass: "course-tip"
  }, [_vm._v("时间表（北京时间）。点击单元格切换状态：√ 可用，? 不确定，× 不可用")]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "24"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "course-table",
    attrs: {
      "role": "grid",
      "aria-label": "老师工作时间表"
    }
  }, [_c('div', {
    staticClass: "course-row course-header"
  }, [_c('div', {
    staticClass: "course-cell time-slot"
  }, [_vm._v("时间")]), _vm._v(" "), _vm._l((_vm.courseDays), function(day) {
    return _c('div', {
      key: day,
      staticClass: "course-cell"
    }, [_vm._v(_vm._s(day))])
  })], 2), _vm._v(" "), _vm._l((_vm.courseSlots), function(slot) {
    return _c('div', {
      key: slot,
      staticClass: "course-row"
    }, [_c('div', {
      staticClass: "course-cell time-slot"
    }, [_vm._v(_vm._s(slot))]), _vm._v(" "), _vm._l((_vm.courseDays), function(day, index) {
      return _c('div', {
        key: day + slot,
        staticClass: "course-cell selectable",
        class: _vm.availabilityClass(index + 1, slot),
        style: ({
          cursor: _vm.canEdit ? 'pointer' : 'default'
        }),
        on: {
          "click": function($event) {
            _vm.canEdit && _vm.toggleAvailability(index + 1, slot)
          }
        }
      }, [_vm._v("\n                          " + _vm._s(_vm.availabilitySymbol(index + 1, slot)) + "\n                        ")])
    })], 2)
  })], 2)])])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.canEdit) ? _c('div', {
    staticClass: "footer"
  }, [_c('Button', {
    staticClass: "cancel",
    attrs: {
      "type": "default",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.insertLoading
    },
    on: {
      "click": _vm.updateTchInfo
    }
  }, [_vm._v("保存")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.referrerTabVisible && _vm.detailTabRules.referrer) ? _c('Tab-pane', {
    attrs: {
      "label": "推荐官",
      "name": "推荐官"
    }
  }, [(_vm.tabName === '推荐官') ? _c('div', {
    staticClass: "referrer-tab"
  }, [_c('Row', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("老师ID：")]), _vm._v(_vm._s(_vm.referrerDetail.referrerId) + "\n            ")]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("姓名：")]), _vm._v(_vm._s(_vm.referrerDetail.referrerName) + "\n            ")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.referrerMonthlyColumns,
      "data": _vm.referrerMonthlyStats,
      "loading": _vm.referrerMonthlyLoading,
      "size": "small",
      "border": ""
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isAddTch && _vm.detailTabRules.colorBlock) ? _c('Tab-pane', {
    attrs: {
      "label": "色块表",
      "name": "色块表"
    }
  }, [_c('div', {
    staticClass: "color-block-container"
  }, [_c('div', {
    ref: "searchWrapper",
    staticClass: "search-wrapper"
  }, [_c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', [_c('i-col', [_c('Form-item', {
    attrs: {
      "label": "选择日期"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "clearable": false,
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择日期",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onColorDateChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', [_c('Checkbox-group', {
    model: {
      value: (_vm.types),
      callback: function($$v) {
        _vm.types = $$v
      },
      expression: "types"
    }
  }, [_c('span', [_vm._v("显示：")]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#00DEFF"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "opened"
    }
  }, [_c('span', [_vm._v("买断时间")])]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#1B5E20"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "shortTerm"
    }
  }, [_c('span', [_vm._v("短期固定时间")])]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#66CC33"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "free"
    }
  }, [_c('span', [_vm._v("临时开课时间")])]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#FF9900"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "schedule"
    }
  }, [_c('span', [_vm._v("常规课")])]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#FFCCFF"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "book"
    }
  }, [_c('span', [_vm._v("绑定时间")])]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#ffff00"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "test"
    }
  }, [_c('span', [_vm._v("试听课")])]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#FF6B6B"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "partner"
    }
  }, [_c('span', [_vm._v("陪练课")])]), _vm._v(" "), _c('i', {
    staticClass: "color",
    staticStyle: {
      "background": "#AEAEAE"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": "leave"
    }
  }, [_c('span', [_vm._v("老师请假")])])], 1)], 1)], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_vm._l((_vm.groupedDataList), function(group, groupIndex) {
    return _c('div', {
      key: groupIndex
    }, [_c('table', {
      staticClass: "table"
    }, [_c('timetable-header', {
      attrs: {
        "columns": _vm.titles
      }
    }), _vm._v(" "), _c('tbody', _vm._l((group), function(item) {
      return _c('timetable-row', {
        key: item.week,
        attrs: {
          "row": item,
          "columns": _vm.titles,
          "types": _vm.types
        }
      })
    }), 1)], 1)])
  }), _vm._v(" "), (!_vm.groupedDataList || _vm.groupedDataList.length === 0) ? _c('table', {
    staticClass: "table"
  }, [_c('tr', {
    staticStyle: {
      "height": "40px",
      "text-align": "center"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "30"
    }
  }, [_vm._v("无数据")])])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.seeStuList && _vm.tchTrackFormData.tchId > 0 && _vm.detailTabRules.bindStu) ? _c('Tab-pane', {
    attrs: {
      "label": "在绑学生",
      "name": "在绑学生"
    }
  }, [_c('List', {
    ref: "dataList",
    staticClass: "pay-list",
    attrs: {
      "tableColumns": _vm.titleStuList,
      "listUrl": "/tch/std-list",
      "params": _vm.tchTrackFormData,
      "onLoading": _vm.onLoading,
      "reload": _vm.reloadStuList,
      "pageSize": 100,
      "sync-route": false
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.seeTchTrack && _vm.detailTabRules.track) ? _c('Tab-pane', {
    attrs: {
      "label": "老师跟踪记录",
      "name": "老师跟踪记录"
    }
  }, [(_vm.tabName === '老师跟踪记录') ? _c('div', [_c('Form', {
    ref: "tchTrackRecordForm",
    staticClass: "form",
    attrs: {
      "model": _vm.tchTrackFormData,
      "rules": _vm.tchTrackRule
    }
  }, [_c('Row', [_c('Row', [_c('Tag', {
    staticStyle: {
      "margin": "0 0 20px 20px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("新增记录")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-Item', {
    attrs: {
      "label-width": 80
    }
  }, [_c('span', [_vm._v("老师：" + _vm._s(_vm.tchTrackFormData.tchId + '-' + _vm.tchTrackFormData.tchName))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("所属外管：" + _vm._s(_vm.tchTrackFormData.studyAdviserName))])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-Item', {
    attrs: {
      "label-width": 130,
      "label": "类型：",
      "prop": "trackType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.tchTrackFormData.trackType),
      callback: function($$v) {
        _vm.$set(_vm.tchTrackFormData, "trackType", $$v)
      },
      expression: "tchTrackFormData.trackType"
    }
  }, _vm._l((_vm.$constant.tchTrackRecordType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                      " + _vm._s(item.text) + "\n                    ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-Item', {
    attrs: {
      "label-width": 130,
      "label": "内容：",
      "prop": "content"
    }
  }, [_c('div', {
    on: {
      "paste": _vm.handleContentPaste
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.tchTrackFormData.content),
      callback: function($$v) {
        _vm.$set(_vm.tchTrackFormData, "content", $$v)
      },
      expression: "tchTrackFormData.content"
    }
  })], 1)])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传附件",
      "prop": "pic"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTrackFileChange,
      "on-success": _vm.trackFileSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUploadTrackFile,
      "limit": 5,
      "multiple": "",
      "file-list": _vm.defaultPicsList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row'), _vm._v(" "), _c('Row', {
    attrs: {
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "soan": 12
    }
  }, [_c('Form-Item', {
    attrs: {
      "label-width": 130
    }
  }, [(_vm.formData.editPermission) ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTrackRecord
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.resetTrackRecord
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin": "0 0 20px 20px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("跟踪记录")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form', [_c('Form-item', {
    attrs: {
      "label": "类型：",
      "label-width": 60
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.trackType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "trackType", _vm._n($$v))
      },
      expression: "queryParam.trackType"
    }
  }, _vm._l((_vm.$constant.tchTrackRecordType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('List', {
    key: 'tch-track-' + (_vm.tchId || 0),
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/tchTrack/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading2,
      "onSelection": _vm.onSelection,
      "operator": "",
      "sync-route": false
    }
  })], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isAddTch && _vm.tchId && _vm.detailTabRules.stat) ? _c('Tab-pane', {
    attrs: {
      "label": "数据统计",
      "name": "数据统计"
    }
  }, [(_vm.tabName === '数据统计') ? _c('div', {
    staticClass: "stat-tab"
  }, [_c('div', {
    staticClass: "stat-toolbar"
  }, [_c('RadioGroup', {
    attrs: {
      "type": "button",
      "disabled": _vm.statLoading
    },
    on: {
      "on-change": _vm.onStatPeriodChange
    },
    model: {
      value: (_vm.statPeriodType),
      callback: function($$v) {
        _vm.statPeriodType = $$v
      },
      expression: "statPeriodType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "day"
    }
  }, [_vm._v("日")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "week"
    }
  }, [_vm._v("周")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "month"
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "year"
    }
  }, [_vm._v("年")])], 1), _vm._v(" "), _c('DatePicker', {
    key: _vm.statPeriodType,
    staticStyle: {
      "width": "160px",
      "margin-left": "12px"
    },
    attrs: {
      "type": _vm.statDatePickerType,
      "format": _vm.statDatePickerFormat,
      "value": _vm.statDate,
      "clearable": false,
      "disabled": _vm.statLoading,
      "transfer": "",
      "placeholder": "选择日期"
    },
    on: {
      "on-change": _vm.onStatDateChange
    }
  }), _vm._v(" "), (_vm.statPeriodType === 'week' && _vm.statWeekRangeText) ? _c('span', {
    staticClass: "stat-week-hint"
  }, [_vm._v(_vm._s(_vm.statWeekRangeText))]) : _vm._e(), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.statLoading
    },
    on: {
      "click": _vm.loadPersonalStat
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "loading": _vm.statExportLoading
    },
    on: {
      "click": _vm.exportPersonalStat
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', {
    staticClass: "stat-grid"
  }, _vm._l((_vm.statCards), function(item) {
    return _c('div', {
      key: item.title,
      staticClass: "stat-card is-clickable",
      on: {
        "click": function($event) {
          return _vm.openStatDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "stat-card-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "stat-card-value"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('div', {
      staticClass: "stat-card-sub"
    }, [_vm._v(_vm._s(item.sub))]), _vm._v(" "), (item.foot) ? _c('div', {
      staticClass: "stat-card-foot"
    }, [_vm._v(_vm._s(item.foot))]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "stat-foot"
  }, [_vm._v("统计截至 " + _vm._s(_vm.personalStat.asOfTime || '—'))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isAddTch && _vm.tchId && _vm.detailTabRules.onboarding) ? _c('Tab-pane', {
    attrs: {
      "label": "开课Checklist",
      "name": "开课Checklist"
    }
  }, [(_vm.tabName === '开课Checklist') ? _c('div', {
    staticClass: "onboarding-tab"
  }, [(_vm.onboardingLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "30px 0"
    }
  }, [_c('Spin', {
    attrs: {
      "size": "large"
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "onboarding-head"
  }, [_c('span', {
    staticClass: "onboarding-progress"
  }, [_vm._v("总进度：" + _vm._s(_vm.onboardingDoneCount) + "/" + _vm._s(_vm.onboardingTotalCount))]), _vm._v(" "), (_vm.onboardingVersionId) ? _c('span', {
    staticClass: "onboarding-version"
  }, [_vm._v("版本 " + _vm._s(_vm.onboardingVersionId))]) : _vm._e()]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.onboardingColumns,
      "data": _vm.onboardingRows,
      "border": "",
      "stripe": "",
      "size": "small"
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isAddTch && _vm.tchId && _vm.detailTabRules.classFeedback) ? _c('Tab-pane', {
    attrs: {
      "label": "老师评分及课堂展示",
      "name": "老师评分及课堂展示"
    }
  }, [(_vm.tabName === '老师评分及课堂展示') ? _c('TeacherClassScore', {
    attrs: {
      "tchId": _vm.tchId
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  }), _vm._v(" "), _c('InvalidListenCauseLogModal', {
    attrs: {
      "tchId": _vm.tchId
    },
    model: {
      value: (_vm.showInvalidListenCauseLog),
      callback: function($$v) {
        _vm.showInvalidListenCauseLog = $$v
      },
      expression: "showInvalidListenCauseLog"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.statDetailModalTitle,
      "width": "880",
      "mask-closable": true,
      "transfer": ""
    },
    model: {
      value: (_vm.showStatDetailModal),
      callback: function($$v) {
        _vm.showStatDetailModal = $$v
      },
      expression: "showStatDetailModal"
    }
  }, [(_vm.statDetailSplit && !_vm.statDetailField) ? _c('div', [_c('p', {
    staticClass: "stat-week-hint",
    staticStyle: {
      "margin": "0 0 12px"
    }
  }, [_vm._v(_vm._s(_vm.statDetailSplitHint))]), _vm._v(" "), _c('div', {
    staticClass: "stat-grid"
  }, [_c('div', {
    staticClass: "stat-card is-clickable",
    on: {
      "click": function($event) {
        return _vm.openStatDetailField('numerator')
      }
    }
  }, [_c('div', {
    staticClass: "stat-card-title"
  }, [_vm._v(_vm._s(_vm.statDetailLeftTitle))]), _vm._v(" "), _c('div', {
    staticClass: "stat-card-value"
  }, [_vm._v(_vm._s(_vm.statDetailLeftValue))]), _vm._v(" "), _c('div', {
    staticClass: "stat-card-sub"
  }, [_vm._v("分子")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card is-clickable",
    on: {
      "click": function($event) {
        return _vm.openStatDetailField('denominator')
      }
    }
  }, [_c('div', {
    staticClass: "stat-card-title"
  }, [_vm._v(_vm._s(_vm.statDetailRightTitle))]), _vm._v(" "), _c('div', {
    staticClass: "stat-card-value"
  }, [_vm._v(_vm._s(_vm.statDetailRightValue))]), _vm._v(" "), _c('div', {
    staticClass: "stat-card-sub"
  }, [_vm._v("分母")])]), _vm._v(" "), (_vm.statDetailHasDiff) ? _c('div', {
    staticClass: "stat-card is-clickable",
    on: {
      "click": function($event) {
        return _vm.openStatDetailField('nonFullLessons')
      }
    }
  }, [_c('div', {
    staticClass: "stat-card-title"
  }, [_vm._v(_vm._s(_vm.statDetailDiffTitle))]), _vm._v(" "), _c('div', {
    staticClass: "stat-card-value"
  }, [_vm._v(_vm._s(_vm.statDetailDiffValue))]), _vm._v(" "), _c('div', {
    staticClass: "stat-card-sub"
  }, [_vm._v("差值")])]) : _vm._e()])]) : _c('div', [(_vm.statDetailSplit) ? _c('div', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.backStatDetailCards.apply(null, arguments)
      }
    }
  }, [_vm._v("返回卡片")]), _vm._v(" "), _c('span', {
    staticClass: "stat-week-hint"
  }, [_vm._v(_vm._s(_vm.statDetailFieldTitle))])]) : _vm._e(), _vm._v(" "), (_vm.statDetailField === 'nonFullLessons') ? _c('p', {
    staticClass: "stat-week-hint",
    staticStyle: {
      "margin": "0 0 12px"
    }
  }, [_vm._v("\n        该老师区间内未全勤课节。迟到写出秒数；请假区分提前请假、临时请假；早退、缺席分别写出。学生请假、管理员取消、学生缺席且老师未缺席的课不计入。\n      ")]) : _vm._e(), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.statDetailColumns,
      "data": _vm.statDetailTableData,
      "loading": _vm.statDetailLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.statDetailTotal,
      "current": _vm.statDetailPageIndex,
      "page-size": _vm.statDetailPageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onStatDetailPageChange,
      "on-page-size-change": _vm.onStatDetailPageSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.statDetailExportLoading,
      "disabled": _vm.statDetailSplit && !_vm.statDetailField
    },
    on: {
      "click": _vm.exportStatDetail
    }
  }, [_vm._v("导出")]), _vm._v(" "), (_vm.statDetailSplit && _vm.statDetailField) ? _c('Button', {
    on: {
      "click": _vm.backStatDetailCards
    }
  }, [_vm._v("返回")]) : _vm._e(), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showStatDetailModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5961c210","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/modal/TchInfoModal.vue
// module id = 1830
// module chunks = 8